import React from 'react';
import { useTranslation } from 'react-i18next';
import TooltipSystemV2 from '../../../components/DesignSystem/TooltipSystemV2/TooltipSystemV2';
import { useGoToLookaheadButton } from './useGoToLookaheadButton';
import { LookaheadOutlineIcon } from '../../../icons';
import { Colors } from '../../../constants/colors.constants';
import './GoToLookaheadButton.scss';

const { BLACK } = Colors;

const GoToLookaheadButton = () => {
  const { t } = useTranslation();

  const {
    hasPermission,
    unsavedChangesListener,
    handleAnimationEnd,
    isShineButton,
    isHasView,
    jsx,
    isLoading
  } = useGoToLookaheadButton();

  const buttonGoToLookahead = (
    <button
      className={`go-to-lookahead-button glow ${
        hasPermission ? '' : 'disabled'
      } ${isShineButton ? 'active' : ''}`}
      onClick={unsavedChangesListener}
      onAnimationEnd={handleAnimationEnd}>
      <div className="go-to-lookahead-button__icon">
        <LookaheadOutlineIcon size={12} color={BLACK} />
      </div>
      <div className="go-to-lookahead-button__text">
        {t(
          isHasView
            ? 'master_plan.button_go_to_lookahead_with_view'
            : 'master_plan.button_go_to_lookahead_without_view'
        )}
      </div>
    </button>
  );

  if (!hasPermission) {
    return (
      <TooltipSystemV2
        title={t('not_permissions_actions')}
        theme="dark"
        placement="topRight">
        {buttonGoToLookahead}
        {jsx}
      </TooltipSystemV2>
    );
  }

  if (isLoading) {
    return <div className="go-to-lookahead-button-loading" />;
  }

  return (
    <>
      {buttonGoToLookahead}
      {jsx}
    </>
  );
};

export default GoToLookaheadButton;
